var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"current-page":_vm.pagination.current,"page-sizes":_vm.pagesizes,"page-size":_vm.pagination.size,"background":"","total":_vm.total},on:{"size-change":_vm.onSizeChange,"current-change":_vm.onCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }